<section
  class="row import-cart"
  [ngClass]="{ 'mt-4': titleShouldShow == false }"
  *ngIf="selectedChannel == 'PRIVATE'">
  <div class="col-md-12" *ngIf="titleShouldShow">
    <h3 class="c-heading c-heading-h2 mb-4 pb-lg-2">
      {{ 'importCart.title' | cxTranslate }}
    </h3>
  </div>
  <div class="col-md-12 text-fixed-medium" id="leftCont-rightNav">
    <div class="account-section-content import-csv__content">
      <div class="well well-quaternary well-md import-csv__well">
        <div class="row">
          <div class="col-lg-6 u-border-right-grey">
            <p>
              <b>{{ 'importCart.steps' | cxTranslate }}</b>
            </p>
            <ul>
              <li>
                {{ 'importCart.step1' | cxTranslate }}
              </li>
              <li>
                {{ 'importCart.step2' | cxTranslate }}
              </li>
              <li>
                {{ 'importCart.step3' | cxTranslate }}
              </li>
            </ul>
            <div class="d-lg-flex">
              <button
                id="exportButtonXLS"
                class="c-button c-button--primary xls mr-lg-2 mb-2"
                (click)="exportXLSX()">
                {{ 'importCart.downloadXlsxFile' | cxTranslate }}
              </button>
              <button
                id="exportButton"
                class="c-button c-button--primary csv ml-lg-2 mb-2"
                (click)="exportCSV()">
                {{ 'importCart.downloadCsvFile' | cxTranslate }}
              </button>
            </div>
          </div>
          <div class="col-lg-6">
            <p>
              <b>
                {{ 'importCart.selectFileToUpload' | cxTranslate }}
              </b>
            </p>
            <div class="form-group file-upload js-file-upload mt-4">
              <div id="chooseFileButton" class="file-upload__wrapper">
                <form [formGroup]="fileUploadForm">
                  <input
                    type="file"
                    id="file-upload"
                    accept=".csv, .xlsx"
                    class="file-upload__input js-file-upload__input customFileInput d-none"
                    (change)="choosefile($event)"
                    [(ngModel)]="fileInput"
                    formControlName="fileUpload" />
                  <label
                    for="file-upload"
                    id="chosenfile"
                    class="text-center d-flex align-items-center justify-content-center"
                    >{{ fileName }}
                    <ng-container *ngIf="fileName == ''">
                      {{ 'importCart.chooseFile' | cxTranslate }}
                    </ng-container></label
                  >
                </form>
              </div>

              <p id="error" class="text-danger"></p>
              <div class="sumbit-button">
                <button
                  id="importButton"
                  (click)="importcsvxls()"
                  [disabled]="!file"
                  class="c-button c-button--primary w-100">
                  {{ 'importCart.import' | cxTranslate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 offset-md-6 text-center">
        <b *ngIf="showSuccessMessage" class="text-success">{{
          'importCart.successMessage' | cxTranslate
        }}</b>
        <b *ngIf="error != ''" class="text-danger">{{ error | cxTranslate }}</b>
      </div>
    </div>
  </div>
</section>
